import { CURRENCY_SIGN } from "@utils/constants";
import { returnImgSrc } from "@utils/helpers";
import { commaNumber } from "@utils/numberHelper";
import { Fragment } from "react";
import { RiArrowRightUpLine } from "react-icons/ri";
import Slider from "react-slick";

const HomePageOfferCard = ({ product, handleOpenScheme }) => {
  const returnProductPrice = (is_multiple_variation, variant) => {
    if (is_multiple_variation) {
      const priceObj = variant.reduce(
        (acc, curr) => {
          const currPrice = curr.price;
          const min = acc.minPrice;
          const max = acc.maxPrice;
          return {
            minPrice:
              min !== 0 ? (min > currPrice ? currPrice : min) : currPrice,
            maxPrice: currPrice > max ? currPrice : max,
          };
        },
        {
          minPrice: 0,
          maxPrice: 0,
        }
      );
      return (
        <>
          <span className='mr-1'>
            {CURRENCY_SIGN} {commaNumber(priceObj?.minPrice)}
          </span>
          -
          <span className='ml-1'>
            {CURRENCY_SIGN} {commaNumber(priceObj?.maxPrice)}
          </span>
        </>
      );
    }
    return (
      <span>
        {CURRENCY_SIGN} {commaNumber(variant?.[0]?.price)}
      </span>
    );
  };
  const setting = {
    dots: false,
    arrows: false,
    autoplay: true,
    infinite: true,
    fade: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className='lg:w-1/3 h-full mt-4'>
      <div
        className='border-2 rounded bg-white group relative  h-full' //cursor-pointer
        // onClick={handleOpenScheme}
      >
        <Slider {...setting}>
          {product?.image?.map((image) => (
            <Fragment key={image.document._id}>
              {
                <>
                  <img
                    src={returnImgSrc(image.document, "200-200")}
                    alt='Carousel-Image'
                    className='mx-auto mt-4'
                  />
                </>
              }
            </Fragment>
          ))}
        </Slider>
        {/* <div className='opacity-0 group-hover:opacity-100 duration-150 bg-black/30 absolute h-full w-full top-0 flex justify-center items-center'>
          <button className='text-white rounded-full p-1 border-white border-2'>
            <RiArrowRightUpLine size='20' />
          </button>
        </div> */}
        <div className='p-2 text-sm flex flex-col '>
          <div>
            <h2 className='font-bold text-lg text-center'>{product?.name}</h2>
          </div>

          <div
            className='font-normal mx-4 mb-2'
            dangerouslySetInnerHTML={{ __html: product?.short_description }}
          />

          {/* <div className='mt-1 font-semibold'>
          {returnProductPrice(product?.is_multiple_variation, product?.variant)}
        </div> */}
        </div>
      </div>
    </div>
  );
};

export default HomePageOfferCard;
